import { defineMessages } from 'react-intl'

const messages = defineMessages({
  errorMessage: {
    id: 'SlackIntegrationSection.errorMessage',
    defaultMessage: 'Failed to load Slack integration configuration',
  },
  addToSlackButton: {
    id: 'SlackIntegrationSection.addToSlackButton',
    defaultMessage: 'Add to Slack',
  },
  notConnectedDescription: {
    id: 'SlackIntegrationSection.notConnectedDescription',
    defaultMessage:
      'Connect your Slack workspace to enable Slack notifications and user linking',
  },
})

export default messages
